/**
 * @author HungNS
 */
/* eslint-disable no-unused-vars */
import {isNil, uniq} from 'lodash'
import moment from 'moment'
import IConstants from '@/common/constants/IConstants'
import i18n from "../../lang/i18n";
import ValidationUtils from '@/common/utils/ValidationUtils.js';

const fileSizeValidation = (value) => {
    if (!value) {
        return true;
    }
    let file = value;
    return (file.size < 5242880);
};

const fileTypeValidation = (value, vm) => {
    if (vm) {
        const FILE_UPLOAD_EXT = vm.fileUploadExt;
        if (FILE_UPLOAD_EXT) {
            var allowFileUpload = FILE_UPLOAD_EXT.split(",");
            if (value) {
                var fileExtensionUpload = value.name.split(".");
                var fileExtension = "." + fileExtensionUpload[fileExtensionUpload.length - 1];
                var invalidExtension = false;
                for (var index in allowFileUpload) {
                    if (fileExtension.toUpperCase() === allowFileUpload[index].trim().toUpperCase()) {
                        invalidExtension = true;
                        break;
                    }
                }
                return invalidExtension;
            }
        }
    }
    return true;
};

const fileTypeValidationForArr = (component) => {
    return (value) => {
        return fileTypeValidation(value, component)
    }
};

const fileCustomerNameDuplicateValidationForArr = (listFile) => {
    return (value) => {
        if (!value || !value.name) return true;
        const currentFileName = value.name;

        const nameCount = listFile
            .map(f => f.fileUpload?.name)
            .filter(name => name === currentFileName).length;

        return nameCount <= 1;
    }
};

const fileCustomerNameDuplicateValidation = (key) => (value, vm) => {
    const fileTypeKey = key.slice(0, key.length - 1);
    let result = true;
    const fileArr = [];
    const data = {...vm.$data};
    if (value) {
        const currentFileName = value.name;
        Object.keys(data).forEach(item => {
            if (item.includes(fileTypeKey) && item !== key) {
                if (!isNil(data[item])) {
                    fileArr.push(data[item].name);
                }
            }
        });
        result = !fileArr.includes(currentFileName);
    }
    return result;
};


const customerNumberValidation = (value) => {
    return !value || /^\d+$/.test(value);
};

const emailValidation = (value) => {
    return ValidationUtils.isEmail(value);
};

const beneficOwnerTypeRequiredValidation = (value) => {
    return value !== IConstants.BENEFIC_OWNER_TYPE.UNDEFINED;
}

const passwordTrimValidation = (value) => {
    return !value || value.trim().length > 0;
};

const phoneNumberValidation = (value) => {
    return !value || (/^\d+$/.test(value) && value.length < 12 && value.length >= 10)
};

const parentCheckboxRequiredValidation = (param) => () => {
    const result = Object
        .values(param)
        .reduce((a, b) => parseInt(a) + parseInt(b));
    if (result == 0) {
        return false
    }
    else {
        return true;
    }
};

function inputAmount(value) {
    if (value)
        value = value.replace(/,/g, '');
    return !value || /^\d+$/.test(value);
}

function validDate(value) {
    if (!value) return false;

    const inputDate = moment(value, "YYYY/MM/DD");
    if (!inputDate.isValid()) return false;

    const serverTime = this.$store.state.dashboard.serverTime ? this.$store.state.dashboard.serverTime : moment().format("YYYY/MM/DD HH:mm:ss");
    const minDate = moment("1900/01/01", "YYYY/MM/DD");

    return inputDate.isSameOrAfter(minDate) && inputDate.isSameOrBefore(serverTime);
}

function passwordCharactersValidation(value) {
    const REQUIRED_PATTERNS = IConstants.REQUIRED_PATTERNS;
    let status = true;
    REQUIRED_PATTERNS.forEach(pattern => {
        status = status && pattern.test(value);
    });
    return status && (value && value.length <= 12 && value.length >= 6);
}

function passwordCharactersValidationIfExist(value) {
    if (!value) {
        return true;
    }

    return passwordCharactersValidation(value);
}

function prefectureIsNotDefaultValue(value) {
    return value !== i18n.t('nts.prefecture.default');
}

function containOnlySpace(value) {
    return !isNil(value) && value.length > 0 && value.trim().length === 0;
}

function regexValidatePassword(password) {
    return !IConstants.PW_NUMBER_ONLY.test(password)
        && !IConstants.PW_LOWER_ONLY.test(password)
        && !IConstants.PW_UPPER_ONLY.test(password)
        && !IConstants.PW_SPECIAL_ONLY.test(password)
        && IConstants.PW_PATTERN_VALID.test(password);
}

function regexValidatePasswordForEa(password) {
    return IConstants.HAVE_NUMBER.test(password)
        && IConstants.HAVE_LOWER.test(password)
        && IConstants.HAVE_UPPER.test(password)
        && IConstants.HAVE_SPECIAL_CHARS.test(password)
        && IConstants.PW_PATTERN_VALID_EA.test(password);
}

const isFullWidthChar = c => {
    return !((c >= 0x0 && c < 0x81) || c === 0xf8f0 || (c >= 0xff61 && c < 0xffa0) || (c >= 0xf8f1 && c < 0xf8f4));
};

const isFullWidth = value => {
    if (!value) return false;
    for (let i = 0; i < value.length; i++) {
        if (isFullWidthChar(value.charCodeAt(i))) {
            return true;
        }
    }
    return false;
};

const blackListDomainsValidation = (mailAddress) => {
    if (!mailAddress) return true;
    return ValidationUtils.validateSpecificMailFormat(mailAddress);
};

export {
    validDate,
    fileTypeValidation,
    fileSizeValidation,
    fileCustomerNameDuplicateValidation,
    customerNumberValidation,
    passwordTrimValidation,
    phoneNumberValidation,
    parentCheckboxRequiredValidation,
    inputAmount,
    passwordCharactersValidation,
    passwordCharactersValidationIfExist,
    prefectureIsNotDefaultValue,
    containOnlySpace,
    regexValidatePassword,
    regexValidatePasswordForEa,
    isFullWidth,
    isFullWidthChar,
    blackListDomainsValidation,
    beneficOwnerTypeRequiredValidation,
    emailValidation,
    fileTypeValidationForArr,
    fileCustomerNameDuplicateValidationForArr
}
